import { useEffect, useState } from "react"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"
import { getCssDemention } from "src/libs/utilities/getCssDemention"
import { ALIGN, ILandingSection, TableContent } from "src/modules/pe-landing-module/data/interfaces"
import VKVideoPlayListPrimitive from "../primitive/VKVideoPlayListPrimitive"
import Dummy from "./Dummy"
import { useComposition } from "src/modules/pe-landing-module/hooks/useComposition"
import DataContentEditor from "../landing-edit/editors/data-content-editor"

/* Protopia Ecosystem component */
export interface ITableProps {
    section: ILandingSection
    data: TableContent
}
const VKVideoPlayList = ({data, ...props}: ITableProps): JSX.Element => {
    const composition = useComposition(props.section)
    const [marginLeft]    = useState<string>(!![ALIGN.END, ALIGN.MIDDLE ].find(e => e === data.horizontal_align)  || !data.horizontal_align ? "auto" : "0")
    const [marginRight]   = useState<string>(!![ALIGN.START, ALIGN.MIDDLE ].find(e => e === data.horizontal_align) || !data.horizontal_align ? "auto" : "0")
    const [marginTop]     = useState<string>(!![ALIGN.END, ALIGN.MIDDLE ].find(e => e === data.vertical_align) || !data.vertical_align ? "auto" : "0")
    const [marginBottom]  = useState<string>(!![ALIGN.START, ALIGN.MIDDLE ].find(e => e === data.vertical_align) || !data.vertical_align ? "auto" : "0")
    const [alignItems]    = useState<string>(!![ALIGN.START, ALIGN.MIDDLE ].find(e => e === data.vertical_align) || !data.vertical_align ? "center" : "flex-start")
    const [justify]       = useState<string>(!![ALIGN.START, ALIGN.MIDDLE ].find(e => e === data.horizontal_align) || !data.horizontal_align ? "center" : "flex-start")
    const [width]         = useState<string>(getCssDemention( data.width,  "inherit" ))
    const [height, ]      = useState<string>(getCssDemention( data.height, "inherit" )) 

    useEffect(() => {
        addCSSClass(
            `landing-vk-video-palylist-${props.section.id}`,
            `.landing-vk-video-palylist-${props.section.id} {
                display: flex;
                flex-direction: column;
                align-items: ${alignItems};
                justify-content: ${justify};
                margin-left: ${marginLeft};
                margin-right: ${marginRight};
                margin-top: ${marginTop};
                margin-bottom: ${marginBottom};
                max-width: ${ width };
                max-height: ${ height };
                width: ${ width };
                height: ${ height };
                z-index:1;
            } 
            `
        )           
        return () => {
            removeCSSClass(`landing-vk-video-${props.section.id}`)
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[])
    return !!data.items?.length
        ?
        <div className={`landing-content-container landing-vk-video-palylist landing-vk-video-palylist-${props.section.id} ${ data.className || "" } `} style={ data.style || {} }  data-type={data.type} data-content-id={data.id}>
            <VKVideoPlayListPrimitive 
                primitive={ {
                    ...data, 
                    containerWidth: composition.width,
                    columnsCount: composition.columns
                } as any }
            />
            <DataContentEditor data={data} section={props.section} />
        </div>
        :
        <Dummy {...{ 
            data: {
                ...data, 
                className: `landing-vk-video-palylist-${props.section.id}`,
                style: {
                    width: data.btnWidth,
                    height: data.btnHeight
                }
            }, 
            ...props 
        }} /> 
}
export default VKVideoPlayList